export default __webpack_public_path__ + "beta-maps-guides-outdoors-960-596ff7814b0fdc4fad6e817b31460dde.webp";